import { Theme, useTheme } from '@mui/material';
import TableRow, { TableRowProps } from '@mui/material/TableRow';

const getBackgroundColor = (
  theme: Theme,
  index: number,
  isColorMix: boolean,
  isSelected?: boolean
) => {
  if (isSelected) {
    return theme.colors.darkPurple;
  }

  if (isColorMix) {
    return index % 2 === 0 ? theme.colors.darkerGrey : theme.colors.black;
  }

  return theme.colors.black;
};

interface Props extends TableRowProps {
  index: number;
  isColorMix: boolean;
  isSelected?: boolean;
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const CardsTableRow = ({
  index,
  isColorMix,
  isSelected,
  onClick,
  onMouseEnter,
  onMouseLeave,
  ...props
}: Props) => {
  const theme = useTheme();
  const backgroundColor = getBackgroundColor(
    theme,
    index,
    isColorMix,
    isSelected
  );
  return (
    <TableRow
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      sx={{
        cursor: 'pointer',
        backgroundColor,
        ':hover': { backgroundColor: theme.colors.darkPurple },
      }}
      {...props}
    />
  );
};
